import { types } from 'mobx-state-tree';

const SearchRedirection = types.model('SearchRedirection', {
  id: types.identifierNumber,
  search_terms: types.optional(types.array(types.string), []),
  link: types.string
});

export default SearchRedirection;
